import React from "react";
import { connect } from 'react-redux';
import { Actions as ACTIONS } from '../../store/actions/leaveActions';
import _ from 'lodash';

import { format } from 'date-fns'
import { ArrowDownTrayIcon, XMarkIcon } from '@heroicons/react/20/solid'
import Spinner from "../common/Spinner";

const AttachmentModal = ({
  leave,
  leaveType,
  showAttachments,
  getAttachment,
  downloading,
}) => {

  if (!leave) {
    return null;
  }

  return (
    <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ display: "block", background: "rgba(0,0,0,0.4)" }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="block block-themed block-transparent remove-margin-b">
            <div className="block-header bg-primary-dark">
              <ul className="block-options">
                <li>
                  <button type="button" onClick={() => { showAttachments(null) }}>
                    <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                  </button>
                </li>
              </ul>
              <h3 className="block-title">Attachments for {leaveType} Leave {format(new Date(leave.date), "do MMM yyyy")}</h3>
            </div>
            <div className="block-content" style={{ minHeight: 200}}>
              {leave.attachments.map(attachment => (
                <div>
                  <span style={{ fontWeight: "bold" }}>{attachment.byName}</span>
                  <span style={{ fontSize: "12px" }}> - {format(new Date(attachment.createdAt), "do MMM yyyy HH:mm")}</span>
                  <p>
                    {attachment.name}
                    {downloading?.includes(attachment.key) ?
                      <a
                        style={{ marginLeft: '5px' }}
                        className="btn btn-xs btn-default"
                      >
                        <Spinner
                          style={{ height: "1.5em", verticalAlign: 'middle', float: "left" }}
                          className="animate-spin -ml-1 mr-3 h-5 w-5 "
                        />
                      </a>
                      :
                      <a
                        onClick={() => {
                          getAttachment({
                            key: attachment.key,
                            agreement: leave.agreement || leave.agreementID || leave.agreementId,
                          })
                        }}
                        style={{ marginLeft: '5px' }}
                        className="btn btn-xs btn-default"
                      >
                        <ArrowDownTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
                      </a>
                    }
                  </p>
                </div>
              ))}
            </div>
            <button className="btn btn-default pull-right" style={{ margin: 20 }} onClick={() => { showAttachments(null) }}>Close</button>
            <div className="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const {
    leaveTypes,
  } = state.leave
  const leave = state.leave.showAttachments;

  return {
    leave,
    modalSaving: state.leave.modalSaving,
    downloading: state.leave.downloading,
    leaveType: leaveTypes && leave && _.find(leaveTypes, { id: leave.type }).name,
  }
}

const mapDispatchToProps = dispatch => ({
  showAttachments: (leave) => dispatch(ACTIONS.showAttachments(leave)),
  getAttachment: (attachment) => dispatch(ACTIONS.getAttachment(attachment)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AttachmentModal) 
